import React, { useRef, useState } from "react";
import { Tabs, Tab, Box, Button, Typography, Stack, Drawer } from "@mui/material";
import { useTranslation } from "react-i18next";
import ScreenSearchSection from "../../../common/chatComponents/ScreenSearchSection";
import { styled } from "@mui/system";
import "../index.css";
import { StyledChatContainer } from "../../../Styled";
import CreateGroup from "../Drawer/CreateGroup";
import GroupMenuDrawer from "../Drawer/ChatGroupDrawer";
import InputDialogComponent from "../../../components/InputDialog";
import GroupMemberDrawer from "../Drawer/GroupMemberDrawer";
import LanguageList from "../Drawer/LanguageList";
import AddMemberGroupDrawer from "../Drawer/AddMemberGroupDrawer";
import Split from "@uiw/react-split";
import { GroupLevelArkchatPermission } from "../../../utils/constant";
import YouTubeAttachmentDrawer from "../Drawer/YouTubeAttachmentdrawer";
import GoogleAttachmentDrawer from "../Drawer/GoogleAttachmentDrawer";
import MediaFiles from "../Drawer/MediaFiles";
import selectGroupicon from "../../../assets/images/chats/select_group.svg";
import GrouMembeMessageReadStatus from "../Drawer/GroupMemberReadStatus";
import groupVector from "../../../assets/images/chats/groupVector.svg";
import TaskListTab from "../Task/TaskListTab";
import ApprovalListTab from "../Approval/ApprovalListTab";
import MarketPlaceViewList from "../../MarketPlace/Index";
import AIQueryPage from "../AI/AIQueryPage";
import useTabState from "../../../customHooks/useTabState";
import MessageList from "../MessageComponent/MessageList";
import TaskUpdate from "../MessageComponent/TaskUpdate";
import LoadingSpinner from "../../../common/LoadingSpinner/LoadingSpinner";
import fileIcon from "../../../assets/images/chats/fileIcon.svg";
import { createStyledIndicatorButton, FilterIcon } from "../../../common/StyledComponents/SideBarComponents";
import AssignTaskDrawers from "../Drawer/AssignTaskDrawers";
import SearchInputFromGroupInfo from "./SearchInputFromGroupInfo";
import { fontSizeSchemes } from "../../../assets/commonFunction";
import LableToolTip from "../../../common/LableToolTip";
import useChatState from "../../../customHooks/useChatState";
import MessageThreadDrawer from "../MessageComponent/MessageThreadDrawer";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import session from "../../../utils/helper";
import ChatInputWrapper from "../ChatInputWrapper";
import ThreadChatInputControl from "../MessageComponent/ThreadChatInputControl";
import SubTaskAISuggestionDrawer from "../MessageComponent/SubTaskAISuggestionDrawer";
import Filtericon from "../../../assets/images/task/Filter_icon.svg";
const classes = {
  Tabs: {
    minHeight: "38px",
    width: "100%",
    "& .MuiTabs-flexContainer": {
      gap: "6%",
      paddingLeft: "0.8rem",
    },
  },
  tabs: {
    color: "black",
    padding: "0px 0px",
    textTransform: "none",
    minWidth: "unset",
    minHeight: "2.2rem",
    // marginRight: "13.5%",
    "&.Mui-selected": {
      color: "black",
    },
    "@media (max-width: 64em)": {
      // marginRight: "2.5rem",
    },
  },
};

const TabPanel = ({ children, value, index }) => (
  <div hidden={value !== index}>{value === index && <Box>{children}</Box>}</div>
);

export const StyledSubHeadingBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  backgroundColor: "#efefef",
  marginBottom: "0.2rem",
});

export const StyledSubHeadingButton = styled(Button)({
  backgroundColor: "#DB0011",
  // padding: "0.3rem 0.5rem",
  padding: "4px 5px",
  color: "#fff",
  fontSize: "0.8rem",
  minWidth: "unset",
  minHeight: "unset",
  borderRadius: "0.15rem",
  boxShadow: "none",
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  // gap: "2px",
  gap: "4px",
  "&:hover": {
    backgroundColor: "#DB0011",
    color: "#fff",
  },
});

const MyTabs = ({
  isSyncing,
  setSellerTabLoading,
  isSellerTabLoading,
  isCreategroupOpen,
  handleClosegroupdrawer,
  setPricingDrawerOpen,
  handlesavearkchatgroup,
  isRequired,
  groupname,
  setGroupname,
  handleNameChange,
  handleDescriptionChange,
  setisTopicOpen,
  dmUserDeatils,
  isTopicOpen,
  setMoveTopicTriggered,
  setMoveTopicMsgId,
  newMessages,
  setNewMessages,
  handleCloseAddPeopleDrawer,
  pubnub,
  setShowSidebar,
  showSidebar,
  setFilterChecked,
  filterChecked,
  isAiQueryHistory,
  setAiQueryHistory,
  isShareAiText,
  setShareAiText,
  setAddpeopledarwer,
  isAddPeopledarwer,
  newGroupName,
  newGroupDescription,
  setNewGroupName,
  setSideBarOpen,
  isSideBarOpen
}) => {
  const { t } = useTranslation();
  const { filterActive, setFilterActive, groupActive, setGroupActive, sidebarLeft, setSidebarLeft } = useChatState({ setisTopicOpen, isTopicOpen });
  const { isGroupmenuOpen, isThreadScreenFromTaskApproval, setLanguageMenuOpen, isLanguageMenuOpen, isGroupmembermenu, delrequired, setdeleteInputVal, delInputval, setDeletegroupmenu, isDeleteGroupmenu, setEditGroupmenu, isEditGroupmenu, setNotificationpreferenceModal, isNotificationpreferenceModalOpen, set24Hour, is24Hour, setDDMMYY, isDDMMYY, setMMDDYY, isMMDDYY, setYYMMDD, isYYMMDD, setDateFormate, setMediaFilesOpen, isMediaFilesOpen, setDatAndTimeModal, isdateAndTimeModalOpen, setReadstatusdrawer, readStatusdrawer, setPrivateDisableChat, isPrivateDisableChat, setdisableprivatechat, isdisableprivatchat, setReplyParentMsg, replyParentMsg, setFileAttachment, fileAttachment, attachmentdrawer, setSelectedAnswer, selecteAnswer, setShowStaredAiHistory, showStaredAiHistory, setShowTempQuery, showTempQuery, setTempAiQuery, tempAiQuery, setAiQueryValue, aiQueryValue, selectRecipientsDrawerOpen, setSelectRecipientsDrawerOpen, setAttachment, isTaskTypeModalOpen, setIsTaskTypeModalOpen, isThreadTaskTypeModalOpen, setIsThreadTaskTypeModalOpen, attachment, setMessageType, isEmailChecked, isMobileChecked, setEmailChecked, setMobileChecked, selectedRecipients, setSelectedRecipients, externalGroupMember, setExternalGroupMemebr, taskAssignedUser, setTaskAssignedUser, dueTime, setDueTime, dueDate, setDueDate, priority, setPriority, isRepeat, setRepeat, repeatType, setRepeatType, selecteRepeatEvery, setSelectedRepeatEvery, setStepper, stepper, setTaskData, taskData, isTaskUpdateOpen, setTaskUpdateOpen, msgType, setUpdateTaskApprovalMsg, updateTaskApprovalMsg, checkedType, setCheckedType, progress, groupList, currentUserData, setThreadOpen, isThreadOpen, isSubTaskSuggestionDrawerOpen, setSubTaskSuggestionDrawerOpen, handleClickTaskUpdate, handleLanguageCloseMenu, handleCloseGroupMenu, handleOpenGroupDrawer, handleclickAttherate, handleChange, handleCloseMemberDrawer, handleSelectedGroupmenu, handleMessageSend, handleUpdateTaskApproval, handleViewThreadClickTaskApprovalTab, handleSendTempMsg, handleNotificationPreference, handleDateTimeUpdate, handleAddgroupMember, handleSearchInputChange, handleUpdateGroupname, handleDeleteGroup, handleOnDeleteInput, handleOnInputChange, handleEditGroup, handleOnChangeNewMessage, handleReadStatusDrawer, handleDisablePrivateChat, handleBacktoMessage, handlegetThreadMessages, handleSendGoogleAttachment, handleCloseGoogleDrawer, handleClickGoogle, handleSendYouTubeAttachment, handleCloseYoutubeDrawer, handleClickYouTube, setTaskModalDeatils, taskModalDeatils, isSearchGroupInfoOpen, handleSearch, setIsSearchGroupInfoOpen, searchInputValue, setSearchInputValue, filteredMessageList, isSearching, highlightText, leaveCompleteTask, setLeaveCompleteTask, isTaskUpdateTypeModalOpen, setIsTaskUpdateTypeModalOpen } 
  = useTabState({
      pubnub,
      setFilterChecked,
      setNewMessages,
      setisTopicOpen,
      newMessages,
      dmUserDeatils,
      setAddpeopledarwer,
      groupname,
      setGroupname,
      setShowSidebar,
      setShareAiText,
      isShareAiText,
  });
  const appContent = t("AppContent", { returnObjects: true });
  const [profileViewData, setProfileViewData] = useState("");
  const [isProfileViewOpen, setProfileViewModal] = useState(false);
  const [selectedSubTask, setSelectedSubTask] = useState([]);
  const aiComponentRef = useRef(null);

  const SmallActionButton = createStyledIndicatorButton("#DB0011");
  const { selectedGroup, currentHomeIndexTab, isAiScreenActive, showStarMessage, isAccountSwitchLoading } = useAppSelectors();
  const isThreadScreen = session.get("isThreadScreen");

  const handleGroupProfileBadgeClick = (
    data,
    isGroup,
    isBuyerSellerGroup = false,
  ) => {
    const viewData = {
      companyName:
        data?.accountDetails?.subscriberFirmName ||
        data?.activeSubscriber?.subscriberFirmName,
      userName: isGroup
        ? null
        : data?.name || `${data?.firstName} ${data?.lastName}`,
      industryName:
        data?.accountDetails?.subscriberAccountIndustry ||
        data?.activeSubscriber?.subscriberAccountIndustry,
      cityName: data?.accountDetails?.city || data?.city,
      industry:
        data?.accountDetails?.subscriberAccountIndustry ||
        data?.subscriberAccountIndustry,
      type:
        data?.accountDetails?.subscriberAccountType ||
        data?.subscriberAccountType,
      countryName: data?.accountDetails?.country || data?.country,
      profileBrief: data?.accountDetails?.profileBrief || data?.profileBrief,
      profileImgUrl: data?.accountDetails?.profileImgUrl || data?.profileImgUrl,
      coverImgUrl: data?.accountDetails?.coverImgUrl || data?.coverImgUrl,
      isGroup: isGroup,
      isBuyerSellerGroup: isBuyerSellerGroup,
      website: data?.accountDetails?.website || data?.website,
      linkedin: data?.accountDetails?.linkedin || data?.linkedin,
      joinedDate: data?.joinedDate
        ? new Date(
            Number(String(data?.joinedDate).slice(0, 13)),
          ).toLocaleDateString()
        : data?.joinedDate,
      memberCount: data?.memberCount || data?.memberCount,
      createdDate: data?.createdDate
        ? new Date(
            Number(String(data?.createdDate).slice(0, 13)),
          ).toLocaleDateString()
        : data?.createdDate,
      groupName: data?.name,
      groupOwner: data?.createdByUserDetails
        ? `${data.createdByUserDetails.firstName || ""} ${
            data.createdByUserDetails.lastName || ""
          }`.trim()
        : "-",
      description: data?.description,
      email: data?.createdByUserDetails?.email,
    };
    setProfileViewData(viewData);
    setProfileViewModal(true);
  };

  const threadInput = ({ hideSuggestBtn = false }) => (
    <ThreadChatInputControl
      handleclickAttherate={handleclickAttherate}
      handleMessageSend={handleMessageSend}
      handleOnChangeNewMessage={handleOnChangeNewMessage}
      newMessages={newMessages}
      handleClickYouTube={handleClickYouTube}
      setFileAttachment={setFileAttachment}
      handleClickGoogle={handleClickGoogle}
      fileAttachment={fileAttachment}
      attachment={attachment}
      isThreadTaskTypeModalOpen={isThreadTaskTypeModalOpen}
      setisTopicOpen={setisTopicOpen}
      setMoveTopicTriggered={setMoveTopicTriggered}
      isTopicOpen={isTopicOpen}
      setAttachment={setAttachment}
      setIsThreadTaskTypeModalOpen={setIsThreadTaskTypeModalOpen}
      replyParentMsg={replyParentMsg}
      setReplyParentMsg={setReplyParentMsg}
      selectedGroup={selectedGroup}
      setMessageType={setMessageType}
      selectRecipientsDrawerOpen={selectRecipientsDrawerOpen}
      taskAssignedUser={taskAssignedUser}
      setTaskModalDeatils={setTaskModalDeatils}
      taskModalDeatils={taskModalDeatils}
      isThreadScreenFromTaskApproval={isThreadScreenFromTaskApproval}
      isPrivateChatOn={
        groupList?.find((item) => item?.pnId === selectedGroup?.pnId)
          ?.isPrivateChatOn
      }
      isTaskUpdateOpen={isTaskUpdateOpen}
      isThreadScreen={isThreadScreen}
      setPricingDrawerOpen={setPricingDrawerOpen}
      stepper={stepper}
      selectedRecipients={selectedRecipients}
      isDisableAssignTaskBtn={
        selectedRecipients?.selectedInternalRecipients?.length !== 0 ||
        selectedRecipients?.selectedExternalRecipients?.length !== 0
      }
      isSubTaskSuggestionDrawerOpen={isSubTaskSuggestionDrawerOpen}
      setSubTaskSuggestionDrawerOpen={setSubTaskSuggestionDrawerOpen}
      hideSuggestBtn={hideSuggestBtn}
    />
  );

  const chatInputWrapper = () => (
    <ChatInputWrapper
      handleclickAttherate={handleclickAttherate}
      handleMessageSend={handleMessageSend}
      handleOnChangeNewMessage={handleOnChangeNewMessage}
      newMessages={newMessages}
      handleClickYouTube={handleClickYouTube}
      setFileAttachment={setFileAttachment}
      handleClickGoogle={handleClickGoogle}
      fileAttachment={fileAttachment}
      attachment={attachment}
      isTaskTypeModalOpen={isTaskTypeModalOpen}
      setisTopicOpen={setisTopicOpen}
      setMoveTopicTriggered={setMoveTopicTriggered}
      isTopicOpen={isTopicOpen}
      setAttachment={setAttachment}
      setIsTaskTypeModalOpen={setIsTaskTypeModalOpen}
      replyParentMsg={replyParentMsg}
      setReplyParentMsg={setReplyParentMsg}
      selectedGroup={selectedGroup}
      setMessageType={setMessageType}
      selectRecipientsDrawerOpen={selectRecipientsDrawerOpen}
      taskAssignedUser={taskAssignedUser}
      setTaskModalDeatils={setTaskModalDeatils}
      taskModalDeatils={taskModalDeatils}
      isThreadScreenFromTaskApproval={
        isThreadScreenFromTaskApproval
      }
      isPrivateChatOn={
        groupList?.find(
          (item) => item?.pnId == selectedGroup?.pnId,
        )?.isPrivateChatOn
      }
      isTaskUpdateOpen={isTaskUpdateOpen}
      isThreadScreen={isThreadScreen}
      setPricingDrawerOpen={setPricingDrawerOpen}
      stepper={stepper}
      selectedRecipients={selectedRecipients}
      isDisableAssignTaskBtn={
        selectedRecipients?.selectedInternalRecipients
          ?.length !== 0 ||
        selectedRecipients?.selectedExternalRecipients
          ?.length !== 0
      }
    />
  )

  return (
    <>
      <Box position={"relative"}>
        <StyledSubHeadingBox>
          <Box display={"flex"} alignItems={"center"} width={"100%"}>
            {currentHomeIndexTab === 3 && !isSideBarOpen &&             
            <SmallActionButton sx={{ml:"0.25rem"}} onClick={()=>setSideBarOpen(true)} size="small" variant="contained">
                <FilterIcon src={Filtericon} />
            </SmallActionButton>}

            <Tabs
              value={currentHomeIndexTab}
              onChange={(event, newValue) => {
                handleChange(event, newValue);
                if(newValue!==3){
                  setSideBarOpen(false);
                }else if(newValue===3){
                  setSideBarOpen(true);
                }
              }}
              TabIndicatorProps={{
                style: { backgroundColor: "#183243" },
              }}
              sx={classes.Tabs}
            >
             
              <Tab disableRipple sx={classes.tabs} label={appContent?.KEY109} />
              <Tab disableRipple sx={classes.tabs} label={appContent?.KEY110} />
              <Tab disableRipple sx={classes.tabs} label={appContent?.KEY111} />
              <Tab disableRipple sx={classes.tabs} label={appContent?.KEY112} />
            </Tabs>
          </Box>
          {currentHomeIndexTab == 0 && (
            <LableToolTip title={appContent?.KEY256}>
              <Box display="flex" justifyContent="flex-start">
                <Button
                  variant="outlined"
                  disabled={!selectedGroup}
                  onClick={() => {
                    setMediaFilesOpen(true);
                  }}
                  sx={{
                    backgroundColor: "#ffff",
                    borderColor: "black",
                    textTransform: "none",
                    height: "30px",
                    color: "#000000",
                    ml: 0,
                    width: "auto",
                    mr: 1.5,
                    padding: "2px 8px", // <-- reduce padding here
                    minWidth: 0, // <-- optional, for tighter fit
                    "&:hover": {
                      backgroundColor: "#ffff",
                      borderColor: "black",
                      textTransform: "none",
                      color: "#000000",
                      width: "auto",
                      mr: 1.5,
                      padding: "2px 8px", // <-- match hover state
                      minWidth: 0,
                    },
                  }}
                >
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    width={"14px"}
                    height={"11px"}
                    mr={"0.4rem"}
                  >
                    <img
                      src={fileIcon}
                      alt="icon"
                      width={"13px"}
                      height={"13px"}
                    />
                  </Box>{" "}
                  <Box sx={{ width: "80px" }}>
                    <Typography
                      fontSize={fontSizeSchemes.font12}
                      fontWeight={400}
                    >
                      File Manager
                    </Typography>
                  </Box>
                </Button>
              </Box>
            </LableToolTip>
          )}

          {currentHomeIndexTab == 0 && (
            <Box display="flex" justifyContent="flex-start">
              <Button
                variant="outlined"
                disabled={!selectedGroup}
                onClick={handleOpenGroupDrawer}
                sx={{
                  backgroundColor: "#ffff",
                  borderColor: "black",
                  textTransform: "none",
                  color: "#000000",
                  height: "30px",
                  ml: 0,
                  width: "2.2rem",
                  "&:hover": {
                    backgroundColor: "#ffff",
                    borderColor: "black",
                    textTransform: "none",
                    color: "#000000",
                    width: "2.2rem",
                  },
                }}
              >
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  width={"14px"}
                  height={"11px"}
                  mr={"0.4rem"}
                >
                  <img
                    src={groupVector}
                    alt="icon"
                    width={"13px"}
                    height={"12px"}
                  />
                </Box>{" "}
                <Box>
                  <Typography
                    fontSize={fontSizeSchemes.font12}
                    fontWeight={400}
                  >
                    More
                  </Typography>
                </Box>
              </Button>
            </Box>
          )}
        </StyledSubHeadingBox>

        <TabPanel value={currentHomeIndexTab} index={0}>
          <StyledChatContainer>
            {selectedGroup?.isGroup && (
              <ScreenSearchSection
                setisTopicOpen={setisTopicOpen}
                setMediaFilesOpen={setMediaFilesOpen}
                isTopicOpen={isTopicOpen}
                selectedGroup={selectedGroup}
                handleAddgroupMember={handleAddgroupMember}
                setAiQueryHistory={setAiQueryHistory}
                setTempAiQuery={setTempAiQuery}
                setShareAiText={setShareAiText}
                setShowStaredAiHistory={setShowStaredAiHistory}
                showStaredAiHistory={showStaredAiHistory}
                setSelectedAnswer={setSelectedAnswer}
                isAiQueryHistory={isAiQueryHistory}
                handleBacktoMessage={handleBacktoMessage}
                isSearchGroupInfoOpen={isSearchGroupInfoOpen}
                handleSearch={handleSearch}
                isPrivateChatOn={
                  groupList?.find((item) => item?.pnId == selectedGroup?.pnId)
                    ?.isPrivateChatOn
                }
                aiComponentRef={aiComponentRef}
              />
            )}

            <>
              {isSyncing && !isAccountSwitchLoading ? (
                <LoadingSpinner />
              ) : (
                <Split
                  mode="vertical"
                  visiable={false}
                  style={{
                    height: !selectedGroup?.isGroup
                      ? "calc(100% + 10px)"
                      : "calc(100% - 29px)",
                    // border:"1px solid blue"
                  }}
                >
                  {selectedGroup ? (
                    <>
                      {isAiScreenActive ? (
                        <>
                          <AIQueryPage
                            isAiQueryHistory={isAiQueryHistory}
                            setAiQueryHistory={setAiQueryHistory}
                            tempAiQuery={tempAiQuery}
                            setTempAiQuery={setTempAiQuery}
                            showTempQuery={showTempQuery}
                            setShowTempQuery={setShowTempQuery}
                            isShareAiText={isShareAiText}
                            setShareAiText={setShareAiText}
                            setNewMessages={setNewMessages}
                            setShowStaredAiHistory={setShowStaredAiHistory}
                            showStaredAiHistory={showStaredAiHistory}
                            setSelectedAnswer={setSelectedAnswer}
                            selecteAnswer={selecteAnswer}
                            setAiQueryValue={setAiQueryValue}
                            aiQueryValue={aiQueryValue}
                            setFileAttachment={setFileAttachment}
                            handleClickGoogle={handleClickGoogle}
                            handleClickYouTube={handleClickYouTube}
                            fileAttachment={fileAttachment}
                            attachment={attachment}
                            isTaskUpdateOpen={isTaskUpdateOpen}
                            setAttachment={setAttachment}
                            setReplyParentMsg={setReplyParentMsg}
                            replyParentMsg={replyParentMsg}
                            handleMessageSend={handleMessageSend}
                            handleclickAttherate={handleclickAttherate}
                            newMessages={newMessages}
                            selectedGroup={selectedGroup}
                            isThreadScreen={isThreadScreen}
                            setisTopicOpen={setisTopicOpen}
                            setMoveTopicTriggered={setMoveTopicTriggered}
                            setMoveTopicMsgId={setMoveTopicMsgId}
                            setTaskData={setTaskData}
                            setTaskUpdateOpen={setTaskUpdateOpen}
                            ref={aiComponentRef}
                            chatInputWrapper={chatInputWrapper}
                          />
                        </>
                      ) : (
                        <>
                          {isSearchGroupInfoOpen && showStarMessage && (
                            <Box
                              display={"flex"}
                              marginTop="0px"
                              space={3}
                              justifyContent={"center"}
                              alignItems={"center"}
                            >
                              <SearchInputFromGroupInfo
                                setMediaFilesOpen={setMediaFilesOpen}
                                handleBacktoMessage={handleBacktoMessage}
                                searchInputValue={searchInputValue}
                                handleSearchInputChange={
                                  handleSearchInputChange
                                }
                                filteredMessageList={filteredMessageList}
                                handleSearch={handleSearch}
                                type="main"
                                isSearching={isSearching}
                              />
                            </Box>
                          )}

                          <MessageList
                            handleSendTempMsg={handleSendTempMsg}
                            handleAddgroupMember={handleAddgroupMember}
                            setMediaFilesOpen={setMediaFilesOpen}
                            setMoveTopicTriggered={setMoveTopicTriggered}
                            setMoveTopicMsgId={setMoveTopicMsgId}
                            handlegetThreadMessages={handlegetThreadMessages}
                            handleBacktoMessage={handleBacktoMessage}
                            setisTopicOpen={setisTopicOpen}
                            handleReadStatusDrawer={handleReadStatusDrawer}
                            setTaskData={setTaskData}
                            setTaskUpdateOpen={setTaskUpdateOpen}
                            handleClickTaskUpdate={handleClickTaskUpdate}
                            setReplyParentMsg={setReplyParentMsg}
                            progress={progress}
                            isSearchGroupInfoOpen={isSearchGroupInfoOpen}
                            handleSearch={handleSearch}
                            setIsSearchGroupInfoOpen={setIsSearchGroupInfoOpen}
                            isPrivateChatOn={
                              groupList?.find(
                                (item) => item?.pnId == selectedGroup?.pnId,
                              )?.isPrivateChatOn
                            }
                            highlightText={highlightText}
                            searchInputValue={searchInputValue}
                          />
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <Stack
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          height: "100%",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={selectGroupicon}
                          style={{ height: "100px" }}
                          alt=""
                        />
                      </Stack>
                    </>
                  )}

                  {!isAiScreenActive && selectedGroup && (
                    chatInputWrapper()
                  )}
                </Split>
              )}
            </>

            <Drawer
              sx={{ zIndex: 1202 }}
              open={isGroupmenuOpen}
              anchor={"right"}
            >
              <GroupMenuDrawer
                handleCloseGroupMenu={handleCloseGroupMenu}
                selectedGroup={selectedGroup}
                handleEditGroup={handleEditGroup}
                // selectedgroupmenu={selectedgroupmenu}
                handleSelectedGroupmenu={handleSelectedGroupmenu}
                setLanguageMenuOpen={setLanguageMenuOpen}
                setDatAndTimeModal={setDatAndTimeModal}
                setNotificationpreferenceModal={setNotificationpreferenceModal}
                setMediaFilesOpen={setMediaFilesOpen}
                setdisableprivatechat={setdisableprivatechat}
              />
            </Drawer>

            <Drawer
              sx={{ zIndex: 1202 }}
              open={isCreategroupOpen}
              anchor={"right"}
            >
              <CreateGroup
                handleClosegroupdrawer={handleClosegroupdrawer}
                handlesavearkchatgroup={handlesavearkchatgroup}
                handleNameChange={handleNameChange}
                handleDescriptionChange={handleDescriptionChange}
                newGroupDescription={newGroupDescription}
                newGroupName={newGroupName}
                isRequired={isRequired}
              />
            </Drawer>

            <Drawer
              sx={{ zIndex: 1202 }}
              open={attachmentdrawer?.isYoutube}
              anchor={"right"}
            >
              <YouTubeAttachmentDrawer
                handleCloseYoutubeDrawer={handleCloseYoutubeDrawer}
                handleSendYouTubeAttachment={handleSendYouTubeAttachment}
                fileAttachment={fileAttachment}
                attachment={attachment}
              />
            </Drawer>

            <Drawer
              sx={{ zIndex: 1202 }}
              open={attachmentdrawer?.isGoogle}
              anchor={"right"}
            >
              <GoogleAttachmentDrawer
                handleCloseGoogleDrawer={handleCloseGoogleDrawer}
                handleSendGoogleAttachment={handleSendGoogleAttachment}
                fileAttachment={fileAttachment}
                attachment={attachment}
              />
            </Drawer>

            <Drawer
              sx={{ zIndex: 1202 }}
              open={isLanguageMenuOpen}
              anchor={"right"}
            >
              <LanguageList
                handleLanguageCloseMenu={handleLanguageCloseMenu}
                setLanguageMenuOpen={setLanguageMenuOpen}
                selectedGroup={selectedGroup}
              />
            </Drawer>

            <Drawer
              sx={{ zIndex: 1202 }}
              open={isMediaFilesOpen}
              anchor={"right"}
            >
              <MediaFiles
                setMediaFilesOpen={setMediaFilesOpen}
                isThreadScreen={isThreadScreen}
              />
            </Drawer>

            <AddMemberGroupDrawer
              isaddmemberOpen={isAddPeopledarwer}
              handleCloseAddPeopleDrawer={handleCloseAddPeopleDrawer}
              selectedGroup={selectedGroup}
            />

            <GroupMemberDrawer
              handleCloseMemberDrawer={handleCloseMemberDrawer}
              isGroupmembermenu={isGroupmembermenu}
            />
          </StyledChatContainer>
        </TabPanel>
        <TabPanel value={currentHomeIndexTab} index={1}>
          <TaskListTab
            setShowSidebar={setShowSidebar}
            handleClickTaskUpdate={handleClickTaskUpdate}
            handleViewThreadClick={handleViewThreadClickTaskApprovalTab}
            currentHomeIndexTab={currentHomeIndexTab}
            setSideBarOpen={setSideBarOpen}
            filterActive={filterActive}
            setFilterActive={setFilterActive}
            groupActive={groupActive}
            setGroupActive={setGroupActive}
            sidebarLeft={sidebarLeft}
            setSidebarLeft={setSidebarLeft}


            // taskTabValue={taskTabValue}
            // setTaskTabValue={setTaskTabValue}
            // selectedTaskmember={selectedTaskmember}
            // setSelectedTaskMember={setSelectedTaskMember}
            // selectedTaskGroup={selectedTaskGroup}
            // setSelectedTaskGroup={setSelectedTaskGroup}
            // filterChecked={filterChecked}
            // setFilterChecked={setFilterChecked}
            // // handleApplyTaskFilter={handleApplyTaskFilter}
            // handlecreategroup={handlecreategroup}
            // handleGroupProfileBadgeClick={handleGroupProfileBadgeClick}
            // SmallActionButton={SmallActionButton}
            
            // handlegroupItemclick={handleTaskGroupOnClick}
            // showInfoMessage={showInfoMessage}
            // setShowInfoMessage={setShowInfoMessage}
          />
        </TabPanel>
        <TabPanel value={currentHomeIndexTab} index={2}>
          <ApprovalListTab
            setShowSidebar={setShowSidebar}
            currentHomeIndexTab={currentHomeIndexTab}
            filterActive={filterActive}
            setFilterActive={setFilterActive}
            setSideBarOpen={setSideBarOpen}
            groupActive={groupActive}
            setGroupActive={setGroupActive}
            sidebarLeft={sidebarLeft}
            setSidebarLeft={setSidebarLeft}
            handleClickTaskUpdate={handleClickTaskUpdate}
            handleViewThreadClick={handleViewThreadClickTaskApprovalTab}
            

            // filterChecked={filterChecked}
            // setFilterChecked={setFilterChecked}
            // handleGroupProfileBadgeClick={handleGroupProfileBadgeClick}


            // sidebarLeft={sidebarLeft}
            // setSidebarLeft={setSidebarLeft}
          />
        </TabPanel>
        <TabPanel value={currentHomeIndexTab} index={3}>
          <MarketPlaceViewList
            setSellerTabLoading={setSellerTabLoading}
            isSellerTabLoading={isSellerTabLoading}
          />
        </TabPanel>

        {/* common drawers */}
        <>
          <Drawer
            disableEnforceFocus
            // hideBackdrop={true}
            anchor={"right"}
            open={isThreadOpen}
            sx={{ zIndex: 1202 }}
          >
            <MessageThreadDrawer
              setMessageThreadOpen={setThreadOpen}
              handleSendTempMsg={handleSendTempMsg}
              setMediaFilesOpen={setMediaFilesOpen}
              setMoveTopicTriggered={setMoveTopicTriggered}
              setMoveTopicMsgId={setMoveTopicMsgId}
              handlegetThreadMessages={handlegetThreadMessages}
              handleBacktoMessage={handleBacktoMessage}
              setisTopicOpen={setisTopicOpen}
              isTopicOpen={isTopicOpen}
              filteredMessageList={filteredMessageList}
              handleReadStatusDrawer={handleReadStatusDrawer}
              setTaskData={setTaskData}
              setTaskUpdateOpen={setTaskUpdateOpen}
              handleClickTaskUpdate={handleClickTaskUpdate}
              setReplyParentMsg={setReplyParentMsg}
              progress={progress}
              searchInputValue={searchInputValue}
              setSearchInputValue={setSearchInputValue}
              isSearchGroupInfoOpen={isSearchGroupInfoOpen}
              handleSearch={handleSearch}
              handleAddgroupMember={handleAddgroupMember}
              handleSearchInputChange={handleSearchInputChange}
              isPrivateChatOn={
                groupList?.find((item) => item?.pnId == selectedGroup?.pnId)
                  ?.isPrivateChatOn
              }
              chatInputControl={threadInput}
            />
          </Drawer>
          <Drawer
            disableEnforceFocus
            // hideBackdrop={true}
            anchor={"right"}
            open={isSubTaskSuggestionDrawerOpen}
            sx={{ zIndex: 1202 }}
          >
            <SubTaskAISuggestionDrawer
              onClose={setSubTaskSuggestionDrawerOpen}
              setNewMessages={setNewMessages}
              selectedSubTask={selectedSubTask}
              setSelectedSubTask={setSelectedSubTask}
              setIsThreadTaskTypeModalOpen={setIsThreadTaskTypeModalOpen}
              setTaskModalDeatils={setTaskModalDeatils}
              handleclickAttherate={handleclickAttherate}
            />
          </Drawer>
          {isEditGroupmenu && (
            <InputDialogComponent
              title="Edit Group"
              open={isEditGroupmenu}
              handleClose={() => setEditGroupmenu(false)}
              onChange={handleOnInputChange}
              value={groupname}
              btnLabel="Update"
              inputLable="group Name"
              isType="edit"
              onClick={handleUpdateGroupname}
            />
          )}

          {isDeleteGroupmenu && (
            <InputDialogComponent
              title="Delete/ Exit Group"
              isType="delete"
              open={isDeleteGroupmenu}
              handleClose={() => {
                setDeletegroupmenu(false);
                setdeleteInputVal("");
              }}
              onChange={handleOnDeleteInput}
              value={delInputval}
              btnLabel="Delete"
              required={delrequired}
              onClick={handleDeleteGroup}
            />
          )}

          {isdisableprivatchat && (
            <InputDialogComponent
              title="Deactivate private chats & To Dos"
              isType="disableprivatechat"
              open={isdisableprivatchat}
              handleClose={() => {
                setdisableprivatechat(false);
              }}
              onChange={(event) => setdisableprivatechat(event.target.checked)}
              value={isPrivateDisableChat}
              btnLabel="save"
              disabled={
                currentUserData?.activePermission ==
                GroupLevelArkchatPermission?.USER
              }
              required={false}
              onClick={handleDisablePrivateChat}
              setPrivateDisableChat={setPrivateDisableChat}
              handleDisableEnablepvtChat={(event) =>
                setPrivateDisableChat(event.target.checked)
              }
            />
          )}

          {isdateAndTimeModalOpen && (
            <InputDialogComponent
              title="Date & time format"
              isType="date&time"
              open={isdateAndTimeModalOpen}
              handleClose={() => {
                setDatAndTimeModal(false);
                setDateFormate("");
              }}
              btnLabel="Save"
              set24Hour={set24Hour}
              setDDMMYY={setDDMMYY}
              isDDMMYY={isDDMMYY}
              setMMDDYY={setMMDDYY}
              isMMDDYY={isMMDDYY}
              setYYMMDD={setYYMMDD}
              isYYMMDD={isYYMMDD}
              is24Hour={is24Hour}
              setDateFormate={setDateFormate}
              onClick={handleDateTimeUpdate}
            />
          )}

          {selectedGroup && (
            <Drawer
              disableEnforceFocus
              hideBackdrop={true}
              open={selectRecipientsDrawerOpen}
              anchor={"right"}
              sx={{ zIndex: isThreadOpen ? 1202 : "" }}
            >
              <AssignTaskDrawers
                setSelectRecipientsDrawerOpen={setSelectRecipientsDrawerOpen}
                setMessageType={setMessageType}
                msgType={msgType}
                selectedRecipients={selectedRecipients}
                setSelectedRecipients={setSelectedRecipients}
                taskAssignedUser={taskAssignedUser}
                setTaskAssignedUser={setTaskAssignedUser}
                dueTime={dueTime}
                setDueTime={setDueTime}
                dueDate={dueDate}
                setDueDate={setDueDate}
                priority={priority}
                setPriority={setPriority}
                isRepeat={isRepeat}
                setRepeat={setRepeat}
                repeatType={repeatType}
                setRepeatType={setRepeatType}
                selecteRepeatEvery={selecteRepeatEvery}
                setSelectedRepeatEvery={setSelectedRepeatEvery}
                stepper={stepper}
                setStepper={setStepper}
                checkedType={checkedType}
                setCheckedType={setCheckedType}
                updateTaskApprovalMsg={updateTaskApprovalMsg}
                setUpdateTaskApprovalMsg={setUpdateTaskApprovalMsg}
                handleUpdateTaskApproval={handleUpdateTaskApproval}
                isTaskUpdateOpen={isTaskUpdateOpen}
                taskData={taskData}
                taskModalDeatils={taskModalDeatils}
                externalGroupMember={externalGroupMember}
                setExternalGroupMemebr={setExternalGroupMemebr}
                setTaskUpdateOpen={setTaskUpdateOpen}
                setTaskData={setTaskData}
                selectRecipientsDrawerOpen={selectRecipientsDrawerOpen}
                handleClickYouTube={handleClickYouTube}
                setFileAttachment={setFileAttachment}
                handleClickGoogle={handleClickGoogle}
                fileAttachment={fileAttachment}
                attachment={attachment}
                setAttachment={setAttachment}
                setIsTaskUpdateTypeModalOpen={setIsTaskUpdateTypeModalOpen}
                isTaskUpdateTypeModalOpen={isTaskUpdateTypeModalOpen}
                handleclickAttherate={handleclickAttherate}
                setTaskModalDeatils={setTaskModalDeatils}
                setSelectedSubTask={setSelectedSubTask}
                setNewMessages={setNewMessages}
                chatInputControl={threadInput}
              />
            </Drawer>
          )}

          <Drawer
            disableEnforceFocus
            // hideBackdrop={true}
            anchor={"right"}
            open={isTaskUpdateOpen}
            sx={{ zIndex: isThreadOpen ? 1202 : "" }}
          >
            <TaskUpdate
              selectedRecipients={selectedRecipients}
              handleUpdateTaskApproval={handleUpdateTaskApproval}
              setTaskUpdateOpen={setTaskUpdateOpen}
              setSelectRecipientsDrawerOpen={setSelectRecipientsDrawerOpen}
              setStepper={setStepper}
              taskData={taskData}
              setTaskData={setTaskData}
              setMessageType={setMessageType}
              msgType={msgType}
              selectRecipientsDrawerOpen={selectRecipientsDrawerOpen}
              handleMessageSend={handleMessageSend}
              newMessages={newMessages}
              handleClickYouTube={handleClickYouTube}
              setFileAttachment={setFileAttachment}
              handleClickGoogle={handleClickGoogle}
              fileAttachment={fileAttachment}
              attachment={attachment}
              setAttachment={setAttachment}
              stepper={stepper}
              setDueDate={setDueDate}
              setDueTime={setDueTime}
              checkedType={checkedType}
              setCheckedType={setCheckedType}
              setReplyParentMsg={setReplyParentMsg}
              updateTaskApprovalMsg={updateTaskApprovalMsg}
              setUpdateTaskApprovalMsg={setUpdateTaskApprovalMsg}
              leaveCompleteTask={leaveCompleteTask}
              setLeaveCompleteTask={setLeaveCompleteTask}
              setTaskModalDeatils={setTaskModalDeatils}
              setIsTaskUpdateTypeModalOpen={setIsTaskUpdateTypeModalOpen}
              isTaskUpdateTypeModalOpen={isTaskUpdateTypeModalOpen}
              handleclickAttherate={handleclickAttherate}
              setIsTaskTypeModalOpen={setIsTaskTypeModalOpen}
              taskModalDeatils={taskModalDeatils}
              setSelectedRecipients={setSelectedRecipients}

            />
          </Drawer>

          <Drawer
            sx={{ zIndex: 1202 }}
            open={readStatusdrawer}
            anchor={"right"}
          >
            <GrouMembeMessageReadStatus
              handleCloseMemberDrawer={() => setReadstatusdrawer(false)}
            />
          </Drawer>

          {isNotificationpreferenceModalOpen && (
            <InputDialogComponent
              title="Notification preference"
              isType="notification"
              open={isNotificationpreferenceModalOpen}
              handleClose={() => {
                setNotificationpreferenceModal(false);
                setDateFormate("");
              }}
              btnLabel="Save"
              onClick={handleNotificationPreference}
              setMobileChecked={setMobileChecked}
              setEmailChecked={setEmailChecked}
              isMobileChecked={isMobileChecked}
              isEmailChecked={isEmailChecked}
            />
          )}
        </>
      </Box>
    </>
  );
};

export default MyTabs;

